import React from 'react';

const lineClass = (message) => {
  const m = (message || '').toLowerCase();
  if (m.includes('early exit')) return 'text-amber-400';
  if (m.includes('primary identity')) return 'text-emerald-400';
  if (m.includes('dorking') || m.includes('brute-force')) return 'text-cyan-300';
  if (m.includes('initializing')) return 'text-slate-400';
  return 'text-slate-300';
};

const SystemTerminal = ({ logs, logEndRef, hideLabel, className }) => {
  const shell = [
    'box-border flex h-full min-h-0 w-full min-w-0 max-w-full flex-shrink flex-col overflow-hidden rounded-2xl border border-slate-200/80 bg-white/75 p-2 shadow-sm dark:border-slate-800',
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={shell}>
      {!hideLabel ? (
        <label className="mb-2 block shrink-0 px-1 font-mono text-[10px] font-black uppercase tracking-widest text-slate-400">
          System Engine Logs
        </label>
      ) : null}
      <div className="min-h-0 min-w-0 max-w-full flex-1 overflow-x-hidden overflow-y-auto custom-scrollbar rounded-xl border border-slate-800 bg-slate-900 p-3 font-mono text-[9px] text-slate-300 shadow-inner">
        {logs.length === 0 && (
          <div className="flex items-center">
            <span className="mr-1 text-lg leading-none font-black text-slate-400">{'>'}</span>
            <span
              className="relative top-[3px] inline-block text-sm leading-none text-slate-300"
              style={{ animation: 'cursor-blink-fast 0.45s steps(1, end) infinite' }}
              aria-label="Waiting cursor"
            >
              _
            </span>
          </div>
        )}
        {logs.map((log, lIdx) => (
          <div key={lIdx} className="mb-1.5 leading-relaxed border-l border-slate-800 pl-2 ml-1">
            <span className="text-slate-500">[{log.timestamp || '--:--:--'}]</span>{' '}
            <span className={lineClass(log.message)}>{log.message}</span>
          </div>
        ))}
        <div ref={logEndRef} />
      </div>
    </div>
  );
};

export default SystemTerminal;
